import { render, staticRenderFns } from "./DepositDialog.vue?vue&type=template&id=147edaa0&scoped=true"
import script from "./DepositDialog.vue?vue&type=script&lang=js"
export * from "./DepositDialog.vue?vue&type=script&lang=js"
import style0 from "./DepositDialog.vue?vue&type=style&index=0&id=147edaa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147edaa0",
  null
  
)

export default component.exports